<template>
    <Wrapper :hero-img="heroImg" :theme="heroImg ? 'blue_wave' : null">
        <div :class="{ container: heroImg }">
            <Breadcrumb :items="breadcrumbItems" />

            <div class="grid grid-cols-12 base-responsive-gap mt-6 pb-72">
                <div class="col-span-12 lg:col-span-7">
                    <h1 class="display"><T t="newsletter.title" /></h1>
                    <p class="lead mt-8 mb-12"><T t="newsletter.lead" /></p>
                    <DripForm />
                </div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import DripForm from '@/components/Forms/DripForm.vue';

export default {
    name: 'Newsletter',
    components: {
        Wrapper,
        DripForm,
    },
    asyncData({ i18n }) {
        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('newsletter.title'), 'newsletter']);

        return {
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('newsletter.index'),
            meta: this.$getPageMetaData('newsletter.index'),
        };
    },
    computed: {
        heroImg() {
            return this.$store.state.data.staticImages.newsletter___hero?.srcSet.lg || null;
        },
    },
};
</script>

<style></style>
